  <template>
  <div class="articles-wrapper">
    <div class="container">
      <div>
        <div ref="inner" class="articles-container">
          <div class="articles" v-for="(item, index) in news" :key="index">
            <div class="date">
              <h2>{{ item.sub_category.name }}</h2>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </div>
            <div class="article-board">
              <img :src="item.image.medium" />
              <h1>
                {{ item.title }}
              </h1>
            </div>
            <div class="viewing-news">
              <div class="view">
                <svg
                  class="view-icon"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M30.8852 15.1335C30.6411 14.7782 24.7742 6.4585 15.4999 6.4585C7.54182 6.4585 0.450461 14.7305 0.152081 15.0831C-0.0506937 15.3234 -0.0506937 15.676 0.152081 15.9175C0.450461 16.2701 7.54182 24.5421 15.4999 24.5421C23.458 24.5421 30.5493 16.2701 30.8477 15.9175C31.035 15.6954 31.0518 15.3737 30.8852 15.1335ZM15.4999 23.2505C9.1203 23.2505 3.0545 17.1666 1.51356 15.5003C3.05196 13.8328 9.11128 7.75022 15.4999 7.75022C22.9646 7.75022 28.2334 13.825 29.5199 15.4655C28.0344 17.0788 21.9338 23.2505 15.4999 23.2505Z"
                      fill="#B4BBC3"
                    />
                    <path
                      d="M15.4997 10.3335C12.6503 10.3335 10.333 12.6508 10.333 15.5002C10.333 18.3497 12.6503 20.667 15.4997 20.667C18.3492 20.667 20.6665 18.3497 20.6665 15.5002C20.6665 12.6508 18.3492 10.3335 15.4997 10.3335ZM15.4997 19.3754C13.3633 19.3754 11.6247 17.6367 11.6247 15.5003C11.6247 13.3639 13.3633 11.6252 15.4997 11.6252C17.6362 11.6252 19.3748 13.3639 19.3748 15.5003C19.3748 17.6367 17.6362 19.3754 15.4997 19.3754Z"
                      fill="#B4BBC3"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="31" height="31" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p class="view-number">{{ item.view_count }}</p>
              </div>
              <div class="link">
                <router-link
                  :to="
                    $i18nRoute({
                      name: 'EditArticle_StaffDetail',
                      params: {
                        id: item.id,
                        lang: `edit-${i18n.global.locale.value}`,
                      },
                    })
                  "
                  class="linkToChange"
                >
                  {{ $t("admin.redactor") }}
                </router-link>
                <div class="container-linkToPage">
                  <svg
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.92174 10.6088H0.197186L4.58942 15L8.98018 10.6088H6.22376C6.61302 5.43405 9.30843 1.25348 12.8029 0.237111C12.2694 0.0820009 11.7171 0 11.1525 0C6.88372 0 3.37028 4.64343 2.92174 10.6088Z"
                      fill="#4D72A6"
                    />
                  </svg>
                  <router-link
                    :to="
                      $i18nRoute({
                        name: 'NewsDetail',
                        params: {
                          slug: item.url,
                        },
                      })
                    "
                    class="linkToPage"
                  >
                    {{ $t("admin.Go_to") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="v-else" v-if="news.length === 0">
          <h1>{{ $t("admin.not_published") }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";
import { useFormatter } from "@/utils/formatter";

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const inner = ref();
    const { i18n } = useLanguage();
    const showSpinner = ref();
    let status = route.params.status;

    console.log(route);
    console.log(i18n.global.locale.value);

    const scrollEnd = () => {
      showSpinner.value = false;
    };

    const pageSize = 10;

    const refreshData = () => {
      store.commit("flushStaffState");
      const { startInfiniteScroll, loadData } = useInfiniteScroll({
        wrapper: inner,
        retrieve: async (load) => {
          store.dispatch("getStaffNews", {
            status: status,
            pageSize,
            load,
          });
        },
        newsCount: computed(() => store.getters.staffCount),
        currentPage: computed(() => store.getters.staffPage),
        pageSize,
        scrollEnd,
      });
      startInfiniteScroll();
      showSpinner.value = true;
      loadData();
    };

    watch(
      () => route.params.status,
      (newVal) => {
        if (newVal) {
          status = newVal;
          refreshData();
        }
      }
    );

    watch(() => i18n.global.locale.value, refreshData, { immediate: true });
    console.log(store.getters.staffNews);

    return {
      showSpinner,
      inner,
      news: computed(() => store.getters.staffNews),
      i18n,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.articles-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow-y: scroll;
  .container {
    margin: auto;
    .v-else {
      h1 {
        font-size: 1.667vw;
        line-height: 1.875vw;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
      }
    }
    .articles {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 27.083vw;
      background-color: #f8f8f8;
      margin-top: 2.344vw;
      padding: 0.5vw 0;
      // font-family: "Montserrat", sans-serif;
      .date {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;

        h2 {
          color: rgba(169, 182, 195, 1);
          font-size: 0.833vw;
          line-height: 0.99vw;
          font-weight: 400;
          margin-left: 0.781vw;
        }
        h3 {
          color: rgba(180, 187, 195, 1);
          font-size: 0.833vw;
          line-height: 0.99vw;
          margin-right: 0.781vw;
        }
      }
      .article-board {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        h1 {
          font-size: 1.146vw;
          line-height: 1.302vw;
          font-weight: 600;
          font-style: normal;
          color: rgba(18, 18, 18, 1);
          margin-top: 0.417vw;
          padding: 0 0.981vw;
        }
        img {
          width: 18.823vw;
          height: 9.104vw;
          object-fit: cover;
          margin-top: 0.417vw;
        }
      }
      .viewing-news {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 1.094vw;

        .view {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-left: 0.521vw;
          p {
            font-size: 1.042vw;
            line-height: 1.25vw;
            font-weight: 400;
            color: rgba(180, 187, 195, 1);
          }
          svg {
            margin-right: 0.521vw;
            width: 1.563vw;
            height: 1.563vw;
          }
        }
        .link {
          display: flex;
          justify-content: center;
          align-items: center;
          .linkToChange {
            color: rgba(77, 114, 166, 1);
            font-size: 1.042vw;
            line-height: 1.25vw;
            font-weight: 400;
            margin-right: 0.521vw;
          }

          .container-linkToPage {
            display: flex;
            margin-right: 0.521vw;
            align-items: center;
            svg {
              width: 0.777vw;
              height: 0.877vw;
            }
            .linkToPage {
              color: rgba(77, 114, 166, 1);
              font-size: 1.042vw;
              line-height: 1.25vw;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
}
.articles-wrapper::-webkit-scrollbar {
  width: 0;
}
@media screen and (max-width: 1366px) {
  .articles-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: scroll;
    height: 100vh;
    padding-bottom: 2vw;
    .container {
      .v-else {
        h1 {
          font-size: 1.625;
          line-height: 1.906em;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
        }
      }
      .articles-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 5vw;
        .articles {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: max-content;
          background-color: #f8f8f8;
          margin-top: 3.255vw;
          width: 67.708vw;
          .date {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;
            padding-top: 0.651vw;

            h2 {
              color: rgba(169, 182, 195, 1);
              font-size: 2.083vw;
              line-height: 2.474vw;
              font-weight: 400;
              margin-left: 1.042vw;
            }
            h3 {
              color: rgba(180, 187, 195, 1);
              font-size: 2.083vw;
              line-height: 2.474vw;
              margin-right: 1.042vw;
            }
          }
          .article-board {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            h1 {
              font-size: 2.865vw;
              line-height: 3.646vw;
              font-weight: 400;
              font-style: normal;
              color: rgba(18, 18, 18, 1);
              margin-top: 1.255vw;
              margin-bottom: 1.302vw;
              padding: 0 0.981vw;
            }
            p {
              font-size: 1.893vw;
              line-height: 2.214vw;
              font-weight: 400;
              color: rgba(74, 74, 74, 1);
              padding: 0 4.167vw;
              margin-top: 1.693vw;
              margin-bottom: 2.604vw;
            }
            img {
              width: 45.057vw;
              height: 20.76vw;
              object-fit: cover;
              margin-top: 1.042vw;
            }
          }
          .viewing-news {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding-bottom: 1.823vw;
            .view {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-left: 3.906vw;
              p {
                font-size: 1.823vw;
                line-height: 2.474vw;
                font-weight: 400;
                color: rgba(180, 187, 195, 1);
              }
              svg {
                margin-right: 1.302vw;
                width: 3.995vw;
                height: 2.953vw;
              }
            }
            .link {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 1.875rem;
              .linkToChange {
                color: rgba(77, 114, 166, 1);
                font-size: 1.823vw;
                line-height: 2.214vw;
                font-weight: 400;
                margin-right: 1.302vw;
              }
              .container-linkToPage {
                svg {
                  width: 1.636vw;
                  height: 1.844vw;
                }
                .linkToPage {
                  color: rgba(77, 114, 166, 1);
                  font-size: 1.823vw;
                  line-height: 2.214vw;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .articles-wrapper {
    .container {
      .v-else {
        h1 {
          font-size: 1em;
          line-height: 1.594em;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
        }
      }
      .articles-container {
        margin-top: 8vw;
        .articles {
          width: 94.667vw;

          .date {
            h2 {
              font-size: 4.267vw;
              line-height: 5.067vw;
              margin-left: 5.067vw;
            }

            h3 {
              font-size: 3.2vw;
              line-height: 4vw;
              margin-right: 5.067vw;
            }
          }

          .article-board {
            h1 {
              font-size: 5.333vw;
              line-height: 6.4vw;
            }

            img {
              width: 55.267vw;
              height: 30vw;
            }

            p {
              font-size: 3.467vw;
              line-height: 5.067vw;
            }
          }

          .viewing-news {
            .view {
              margin-left: 6.667vw;
              p {
                font-size: 3.733vw;
                line-height: 4.533vw;
              }
              svg {
                width: 6.667vw;
                height: 6.667vw;
              }
            }

            .link {
              margin-right: 6.667vw;
              align-items: center;

              .linkToChange {
                font-size: 3.733vw;
                line-height: 4.533vw;
              }

              .container-linkToPage {
                display: flex;
                margin-left: 0.3rem;

                svg {
                  width: 4vw;
                  height: 4vw;
                }

                .linkToPage {
                  font-size: 3.733vw;
                  line-height: 4.533vw;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
